/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Payments_View_ReceiptInputs */

const fr_payments_view_receipt = /** @type {(inputs: Payments_View_ReceiptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voir le reçu`)
};

/**

* @param {Payments_View_ReceiptInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const payments_view_receipt = /** @type {((inputs?: Payments_View_ReceiptInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Payments_View_ReceiptInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_payments_view_receipt(inputs)
});